import moment from 'moment';

const calculateNextEventDate = (recordDate, frequencyInDays) => {
  const value = moment(new Date(recordDate), 'YYYY-MM-DD').add(
    'months',
    frequencyInDays
  );
  return value;
};

export default calculateNextEventDate;
